import React from 'react';
import {useIntl} from 'react-intl';
import AppInput from '@components/Core/inputs/AppInput/AppInput';

export default function ReassignForm({form, changeForm}) {
    const intl = useIntl();

    return (
        <div>
            <AppInput
                label={intl.formatMessage({id: 'oss.components.Reassign.firsNameLabel'})}
                name="first_name"
                value={form.first_name}
                onChange={changeForm}
                required
            />
            <AppInput
                label={intl.formatMessage({id: 'oss.components.Reassign.lastNameLabel'})}
                name="last_name"
                value={form.last_name}
                onChange={changeForm}
                required
            />
            <AppInput
                label={intl.formatMessage({id: 'oss.components.Reassign.emailLabel'})}
                name="email"
                type="email"
                value={form.email}
                onChange={changeForm}
                required
            />
            <AppInput
                label={intl.formatMessage({id: 'oss.components.Reassign.titleLabel'})}
                name="title"
                value={form.title || ''}
                onChange={changeForm}
            />
            <AppInput
                label={intl.formatMessage({id: 'oss.components.Reassign.companyLabel'})}
                name="organisation"
                value={form.organisation || ''}
                onChange={changeForm}
            />
            <AppInput
                label={intl.formatMessage({id: 'oss.components.Reassign.personalMessageLabel'})}
                name="personal_message"
                multiline
                rows={3}
                value={form.personal_message || ''}
                onChange={changeForm}
            />
        </div>
    );
}
